import lazyGettext from 'js-utils/lazy-gettext';
import { UNLIMITED } from './featuresComparison';
import {
    AR_LOCALE,
    AU_LOCALE,
    BE_LOCALE,
    BR_LOCALE,
    CA_LOCALE,
    DE_LOCALE,
    ES_LOCALE,
    FR_CA_LOCALE,
    FR_LOCALE,
    GB_LOCALE,
    HK_LOCALE,
    IE_LOCALE,
    IT_LOCALE,
    NL_LOCALE,
    NZ_LOCALE,
    PT_LOCALE,
    SG_LOCALE,
    US_LOCALE,
} from 'js-utils/intl';

export const PACKAGE_ONE_FEATURES_A = [
    lazyGettext('One ticket type (ex. "General Admission")'),
    lazyGettext('Ticketing & registration essentials'),
    lazyGettext('Listing on Eventbrite and partner sites'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_TWO_FEATURES_A = [
    lazyGettext('Everything in Essentials'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Reserved seating'),
    lazyGettext('Phone, chat, and email support'),
];

export const PACKAGE_TWO_FEATURES_A_US = [
    lazyGettext('Everything in Essentials'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Payouts before your event'),
    lazyGettext('Phone, chat, and email support'),
];

export const PACKAGE_TWO_FEATURES_A_MX = [
    lazyGettext('Everything in Essentials'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Reserved seating'),
];

export const PACKAGE_THREE_FEATURES_A = [
    lazyGettext('Everything in Professional'),
    lazyGettext('On-site staffing, support, and rental equipment'),
    lazyGettext('Branded community pages'),
    lazyGettext('Product training'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_THREE_FEATURES_A_AR_BR = [
    lazyGettext('Everything in Professional'),
    lazyGettext('On-site staffing, support, and rental equipment'),
    lazyGettext('Product training'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_THREE_FEATURES_A_MX = [
    lazyGettext('Everything in Professional'),
    lazyGettext('Product training'),
];

export const PACKAGE_THREE_FEATURES_A_HK_SG = [
    lazyGettext('Everything in Professional'),
    lazyGettext('Product training'),
    lazyGettext('Online Help Center'),
];

export const CUSTOMER_SUPPORT = {
    title: lazyGettext('Customer Support'),
    perPlanData: [
        lazyGettext('Online help center'),
        lazyGettext('Online help center'),
        lazyGettext('Online help center'),
    ],
};

export const CUSTOMER_SUPPORT_WITH_PHONE = {
    title: lazyGettext('Customer Support'),
    perPlanData: [
        lazyGettext('Online help center'),
        lazyGettext('Online help center'),
        lazyGettext('Phone support M-F (business hours)'),
    ],
};
export const CUSTOMER_SUPPORT_PROPLUS = {
    title: lazyGettext('Customer Support'),
    perPlanData: [
        lazyGettext('Online help center'),
        lazyGettext('Online help center'),
        lazyGettext('Phone, chat, and email support for free and paid events'),
    ],
};

export const TICKET_TYPES = {
    title: lazyGettext('Ticket types (e.g. "General Admission")'),
    perPlanData: ['1', UNLIMITED, UNLIMITED],
};

export const TR_ESSENTIALS = {
    title: lazyGettext('Ticketing & registration essentials'),
    perPlanData: [true, true, true],
};

export const LISTING_PARTNER_SITES = {
    title: lazyGettext('Listing on Eventbrite and partner sites'),
    perPlanData: [true, true, true],
};

export const TICKET_SALES_SITE = {
    title: lazyGettext('Ticket sales on your own site'),
    perPlanData: [false, true, true],
};

export const CUSTOMIZABLE_CHECKOUT_FORMS = {
    title: lazyGettext('Customizable checkout forms'),
    perPlanData: [false, true, true],
};

export const DETAIL_SALES_ANALYTICS = {
    title: lazyGettext('Detailed sales analytics'),
    perPlanData: [false, true, true],
};

export const PAYOUTS_BEFORE_EVENT = {
    title: lazyGettext('Payouts before your event'),
    perPlanData: [false, true, true],
};

export const ONSITE_RENTAL_SUPPORT = {
    title: lazyGettext('On-site staffing support & rental equipment'),
    perPlanData: [false, false, true],
};

export const BRANDED_PAGES = {
    title: lazyGettext('Branded community pages'),
    perPlanData: [false, false, true],
};

export const COPY_TICKET_DETAILS = {
    title: lazyGettext(
        'Copy ticket settings across multiple ticket types within an event',
    ),
    perPlanData: [false, false, true],
};

export const APPLY_TICKET_TYPES = {
    title: lazyGettext('Save and apply ticket types across multiple events'),
    perPlanData: [false, false, true],
};

export const PREMIUM_TEXT = {
    header: lazyGettext('Do you host large and complex events?'),
    secondaryHeader: lazyGettext('Rely on a proven partner.'),
};

export const ANNUAL_FEE_NONE = lazyGettext('$0');
export const ANNUAL_FEE_CUSTOM = lazyGettext('Custom');

export const ANNUAL_PRICE_PER_LOCALE = {
    [AR_LOCALE]: '$2,995',
    [AU_LOCALE]: 'A$395',
    [BE_LOCALE]: '€395',
    [BR_LOCALE]: 'R$745',
    [DE_LOCALE]: '€395',
    [ES_LOCALE]: '€395',
    [FR_LOCALE]: '€395',
    [GB_LOCALE]: '£250',
    [HK_LOCALE]: '$495',
    [IE_LOCALE]: '€495',
    [IT_LOCALE]: '€395',
    [NL_LOCALE]: '€395',
    [NZ_LOCALE]: 'NZ$395',
    [PT_LOCALE]: '€395',
    [SG_LOCALE]: '$495',
    [US_LOCALE]: '$495',
    [CA_LOCALE]: 'CA$250',
    [FR_CA_LOCALE]: 'CA$250',
};
